module.exports = __webpack_public_path__ + "static/job-detail.56d99a28.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/job-detail.png
// module id = 1027
// module chunks = 2